// Every colour SVG of the cryptocurrency-icons package (CC0-1.0), bundled at
// build time by Vite as its own file (never inlined into the JavaScript:
// there are 483 of them) and keyed by its lower-case ticker. Webpack's
// require.context did this under Create React App. Jest can't read
// import.meta, so tests get jest/coinIconUrlsStub.cjs instead: no icons,
// every coin a monogram, as before.
const files = import.meta.glob<string>('/node_modules/cryptocurrency-icons/svg/color/*.svg', {
  eager: true,
  query: '?no-inline',
  import: 'default',
})

export const ICON_URLS: Record<string, string> = Object.fromEntries(
  Object.entries(files).map(([path, url]) => [path.slice(path.lastIndexOf('/') + 1, -'.svg'.length), url])
)
